// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.example-container {
    display: flex;
    flex-direction: column;
    width: 80%;
    margin-left: auto;
    margin-right: auto;
  }
  
 mat-card div > * {
    width: 100%;
    text-align: center;
  }

  .green{
      background-color: green;
      color: white;
      font-size: 25px;
  }

  .warning{
    background-color: yellow;
    color: black;
    font-size: 25px;
}

.danger{
    background-color: red;
    color: white;
    font-size: 20px;
}

.blue{
    background-color: #005776;
    color: white;
    font-size: 20px;
}

.tempcheck{
    background-color:#ff8c00;
    color: white;
    font-size: 25px;
}



  @media(max-width:762px){
      .example-container{
          width: 100%;
      }
  }

  .button {
    position: relative;
    text-decoration: none;
    padding: 4px;
    padding-left: 12px;
    padding-right: 12px;
    border-radius: 4px;
    /* margin-top: 100px; */
    display: inline-block;
    float: right;
}


/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/monkeypox-survey/monkeypox-report.component.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,iBAAiB;IACjB,kBAAkB;EACpB;;CAED;IACG,WAAW;IACX,kBAAkB;EACpB;;EAEA;MACI,uBAAuB;MACvB,YAAY;MACZ,eAAe;EACnB;;EAEA;IACE,wBAAwB;IACxB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,wBAAwB;IACxB,YAAY;IACZ,eAAe;AACnB;;;;EAIE;MACI;UACI,WAAW;MACf;EACJ;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IAGnB,kBAAkB;IAClB,uBAAuB;IACvB,qBAAqB;IACrB,YAAY;AAChB;;;AACA,w7EAAw7E","sourcesContent":[".example-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    width: 80%;\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n  }\r\n  \r\n mat-card div > * {\r\n    width: 100%;\r\n    text-align: center;\r\n  }\r\n\r\n  .green{\r\n      background-color: green;\r\n      color: white;\r\n      font-size: 25px;\r\n  }\r\n\r\n  .warning{\r\n    background-color: yellow;\r\n    color: black;\r\n    font-size: 25px;\r\n}\r\n\r\n.danger{\r\n    background-color: red;\r\n    color: white;\r\n    font-size: 20px;\r\n}\r\n\r\n.blue{\r\n    background-color: #005776;\r\n    color: white;\r\n    font-size: 20px;\r\n}\r\n\r\n.tempcheck{\r\n    background-color:#ff8c00;\r\n    color: white;\r\n    font-size: 25px;\r\n}\r\n\r\n\r\n\r\n  @media(max-width:762px){\r\n      .example-container{\r\n          width: 100%;\r\n      }\r\n  }\r\n\r\n  .button {\r\n    position: relative;\r\n    text-decoration: none;\r\n    padding: 4px;\r\n    padding-left: 12px;\r\n    padding-right: 12px;\r\n    -webkit-border-radius: 4px;\r\n    -moz-border-radius: 4px;\r\n    border-radius: 4px;\r\n    /* margin-top: 100px; */\r\n    display: inline-block;\r\n    float: right;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
